import { useCoarsePointer } from './use-coarse-pointer';
import { useNarrow } from './use-narrow';

/**
 * The reader is on a PHONE: a touch-only pointer (`hover: none`) AND a narrow viewport (below 720px). Either alone is
 * not enough — a narrow desktop window has a mouse, and a tablet is touch but wide.
 *
 * Used where a phone browser genuinely cannot do the thing: Wix's Editor and Studio do not run on a phone, so a
 * desktop-only editor link becomes a "desktop only" notice there (`lib/presence-checklist.ts`). The same line is drawn
 * on iOS (`userInterfaceIdiom == .phone`; iPad is a computer) and Android (not `isTabletScale`). Change one, change all
 * three. SSR and the first client frame read false (a computer), the hooks' own defaults.
 */
export function useIsPhone(): boolean {
  const coarse = useCoarsePointer();
  const narrow = useNarrow();
  return coarse && narrow;
}
